<template>
    <v-container>
        <v-row v-if="text && text != ''">
            <v-col>
                <v-alert border="top"
                        colored-border
                        type="info"
                        elevation="2"
                >
                    {{ text }}
                </v-alert>
            </v-col>
        </v-row>
         <v-row>
             <v-col>
                <v-autocomplete
                    multiple
                    v-model="disciplines"
                    :items="displayItems"
                    :search-input.sync="searchTerm"
                    no-filter
                    hide-no-data
                    placeholder="Digite o nome ou código para buscar"
                    return-object
                    item-text="name_complete"
                    sort-by="name"
                    :loading="loading"
                    chips
                    label="Selecione as disciplinas"
                    deletable-chips
                    clearable
                    auto-select-first
                >
                    <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click:close="remove(data.item)"
                        >
                            <span>
                                {{ data.item.name_complete }}
                                <small class="ma-0 pa-0" v-if="data.item.type"><br/>{{ data.item.type.name }}</small>
                            </span>
                            
                            <span v-if="data.item.syllabus">
                                <emc-info-help title="Ementa" :text="data.item.syllabus" />
                            </span>
                            
                        </v-chip>
                    </template>

                    <template v-slot:item="data">
                        <span>
                            {{ data.item.name_complete }}
                            <small class="ma-0 pa-0" v-if="data.item.type"><br/>{{ data.item.type.name }}</small>
                        </span>
                        
                        <span v-if="data.item.syllabus">
                            <emc-info-help title="Ementa" :text="data.item.syllabus" />
                        </span>
                    </template>
                    
                </v-autocomplete>
             </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-spacer></v-spacer>
                <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                    <v-btn :disabled="items.length == 0" :loading="loadingSave" v-on="on" color="primary" dark @click="save()">
                        <v-icon dark>save</v-icon>
                            Salvar
                    </v-btn>
                    </template>
                    <span>Salvar</span>
                </v-tooltip>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysTeacherDiscipline",
    data: (vm) => ({
        collection: [],
        showDelete: false,
        dialogAdd: false,
        selectedItem: null,
        disciplines: [],
        items: [],
        searchTerm: '',
        searchTimer: null,
        perPage: 500,
        loading: false,
        loadingSave: false,
        headers: [
            { text: 'Disciplina', value: 'name'},
            { text: 'Ações', value: 'actions', sortable: false}
        ]
        
    }),
    created(){
       this.getDisciplines(true);
    },

    computed: {
      ...mapState('auth', ['acesso']),

      // Mantém as disciplinas já selecionadas na lista para os chips continuarem renderizando
      displayItems(){
          const ids = new Set(this.items.map(i => i.id));
          return [...this.disciplines.filter(d => !ids.has(d.id)), ...this.items];
      },
    },

    watch: {

        searchTerm(val){
            // Seleção de um item preenche o input com o texto do item: não refaz a busca
            if(this.disciplines.some(d => d.name_complete === val)){
                return;
            }
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.getDisciplines(), 350);
        },

        teacher(val){
            this.getData();
        },
            
    },
    props: {
        teacher: {

        },
        token:{
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        }
    },
    methods:{
        ...mapActions('teacher', ['ActionFindTeacher', 'ActionFindTeacherByToken', 'ActionUpdateDisciplines', 'ActionUpdateDisciplinesToken']),
        ...mapActions('discipline', ['ActionFindDisciplines', 'ActionFindDisciplinesToken']),
        
        getDisciplines(initial = false){

             this.loading = true;
            
            if(this.token){
                
                var payload = {
                    token: this.token,
                    per_page: this.perPage,
                    search: this.searchTerm || undefined,
                };
                
                this.ActionFindDisciplinesToken(payload)
                    .then((res) => {
                        this.items = res.data;
                        if(initial) this.getData();
                    })
                    .catch((error) =>{
                        
                    })
                    .finally(() => {
                        if(!initial) this.loading = false;
                    });
            }else{
                
                var payload = {
                    find_columns: {
                        active: 1,
                        show_availability: 1
                    },
                    with: 'type',
                    page: 1,
                    per_page: this.perPage,
                    search: this.searchTerm || undefined,
                    column_order: 'name',
                    direction: 'asc'
                }
               
                this.ActionFindDisciplines(payload)
                    .then((res) => {
                        this.items = res.data;
                        if(initial) this.getData();
                    })
                    .catch((error) =>{
                        
                    })
                    .finally(() => {
                        if(!initial) this.loading = false;
                    });
            }

        },
        
        getData(){
            
            if(!this.teacher || !this.teacher.id || this.teacher.id == 0){
                return;
            }

            this.loading = true;
            var payload = {
                token: this.token,
                with: 'disciplines'
            };

            if(this.token){
                this.ActionFindTeacherByToken(payload)
                    .then((res) => {
                        this.disciplines = res.data.disciplines;
                    })
                    .catch((error) =>{
                        
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }else{
                
                var payload = {
                    id: this.teacher.id ,
                    with: 'disciplines'
                };
                
                this.ActionFindTeacher(payload)
                    .then((res) => {
                        this.disciplines = res.data.disciplines;
                    })
                    .catch((error) =>{
                        
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        
        save(){

            if(this.loading){
                return;
            }
            
            if(!this.teacher || !this.teacher.id || this.teacher.id == 0){
                return;
            }

            this.loadingSave = true;
            var method = this.token ? 'ActionUpdateDisciplinesToken' : 'ActionUpdateDisciplines';
            var payload = {
                    disciplines: this.disciplines.map(o => ({ discipline_id: o.id }))
                };

            if(this.token){
                payload.token = this.token;
            }else{
                payload.id = this.teacher.id;
            }

            this[method](payload)
                .then((res) => {
                    this.$emit('onComplete', { text:'Disciplinas atualizadas com sucesso!', error: false  });
                })
                .catch((error) =>{
                    this.$emit('onComplete', { text:'Erro ao atualizar as disciplinas!', error: false  });
                })
                .finally(() => {
                    this.loadingSave = false;
                });
        },

        remove (item) {
            const find = this.disciplines.find(i => i.id == item.id);
            const index = this.disciplines.indexOf(find);
            if (index >= 0) this.disciplines.splice(index, 1);
      },

    }
}
</script>